import { Alert, type SxProps, type Theme } from "@mui/material";

interface ChartHiddenContentWarningProps {
  datasetId?: string | null;
  /** Defaults to the chart-drawer copy; pass a custom message for non-chart
   *  consumers (e.g. the Dataset Base Definitions editor). */
  message?: string;
  /** Defaults to the chart drawer's own spacing (mx: 2, mt: 2); override for
   *  layouts that already provide spacing via a flex gap. */
  sx?: SxProps<Theme>;
}

/**
 * Non-blocking notice shown when a saved chart references dataset content
 * that is now hidden — the chart keeps its saved calculation either way, so
 * this never gates Save.
 *
 * Uses a plain anchor rather than react-router-dom's Link: the chart config
 * drawer is mounted outside the router tree (shown/hidden via Redux state,
 * not as part of a routed page), so Link's useContext has no Router
 * ancestor and throws.
 */
export default function ChartHiddenContentWarning({
  datasetId,
  message = "This chart uses content that is now hidden in the dataset. The saved analysis is unaffected.",
  sx = { mx: 2, mt: 2 },
}: ChartHiddenContentWarningProps) {
  return (
    <Alert severity="warning" sx={sx}>
      {message}
      {datasetId && (
        <a
          href={`/datasets/${datasetId}?tab=questions`}
          style={{
            display: "block",
            marginTop: 4,
            color: "#1976d2",
            fontWeight: 600,
            textDecoration: "underline",
          }}
        >
          Review in Questions
        </a>
      )}
    </Alert>
  );
}
